import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RcLoginComponent } from './rc-login.component';
import { RcOtpComponent } from './rc-otp/rc-otp.component';
import {RcUiModule} from '../rc-ui/rc-ui.module';
import {RcUtilsModule} from '../rc-utils/rc-utils.module';

@NgModule({
  imports: [
    RcUiModule,
    CommonModule,
    RcUtilsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [RcLoginComponent, RcOtpComponent],
  exports: [RcLoginComponent, RcOtpComponent]
})
export class RcLoginModule { }
